import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDescription',
    standalone: false
})
export class FormatDescriptionPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const escaped = this.escapeHtml(value);
    const blocks = escaped.split(/\n\n+/);

    return blocks.map(block => this.formatBlock(block)).join('');
  }

  private formatBlock(block: string): string {
    const lines = block.split('\n').map(line => line.trim()).filter(line => line);

    if (lines.length === 0) {
      return '';
    }

    const bulletPattern = /^[\u2022\-\*]\s+/;
    const allBullets = lines.every(line => bulletPattern.test(line));

    if (allBullets) {
      const items = lines.map(line => `<li>${line.replace(bulletPattern, '')}</li>`).join('');
      return `<ul>${items}</ul>`;
    }

    // Within a prose block, single newlines join so legacy or unstructured
    // sources render as flowing paragraphs; a short line ending in ':'
    // promotes to a strong header.
    const parts: string[] = [];
    let buffer: string[] = [];
    const flush = () => {
      if (buffer.length) {
        parts.push(`<p>${buffer.join(' ')}</p>`);
        buffer = [];
      }
    };

    for (const line of lines) {
      if (line.endsWith(':') && line.length < 80) {
        flush();
        parts.push(`<p><strong>${line}</strong></p>`);
      } else {
        buffer.push(line);
      }
    }
    flush();
    return parts.join('');
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
